import {useState,useEffect} from 'react'
import {Link} from 'react-router-dom'

//images
import CalendarIcon from '../../../images/request-icons/calendar.svg'
import FloorPlanIcon from '../../../images/request-icons/floor_plan.svg'
import LocationIcon from '../../../images/request-icons/location.svg'
import ViewIcon from '../../../images/admin-icons/eye-icon.svg'
import {ReactComponent as DeleteIcon} from '../../../images/admin-icons/trash-icon.svg'

import { REQUESTED_PROPERTY_DECLINE_REASON } from '../../../constant/requested-poperty-decline-reason'

//styles
import '../styles/request-properties-card.css'
import RequestHelper from '../../../utils/helper'
import { putCancelRequestedProperty } from "../../../utils/my-requests"

const RequestPropertiesCard = ({ id, floorPlan, floorPlanTypeId, name, building, image, address, dates, hiddeActions, declineReason, requestId,bookedFilter }) => {
    const [cancelledStatus, setCancelledStatus] = useState(null)
    const cancelRequestedProperty = async () => {
        let response = await putCancelRequestedProperty(requestId, id, floorPlanTypeId)
        if(response)
            {
                setCancelledStatus(REQUESTED_PROPERTY_DECLINE_REASON.DeclinedByGuest)
            }
    }
    useEffect(() => {
        setCancelledStatus(declineReason)
    }, [declineReason])

  return (
    <div className='request-properties-card' style={bookedFilter ? {display:'none'} : {}}>
        <div className='request-properties-card__img'>
                <img
                style={{
                    backgroundImage: `url(${image})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    textIndent: '-10000px'
                  }}
                  alt={""}
                />
        </div>
        <div className='request-properties-card__name'>
            <span>{name}</span>
            <span className='request-properties-card__name__building'>{building}</span> 
        </div>
        <div className='request-properties-card__address'>
            <img src={LocationIcon} alt={""} /><span>{address.replace(/,\s*,/g, ', ').replace(/^,/, '')}</span>
            {/* <img src={LocationIcon} alt={""} /><span>{address.replace(/\s+/g,'').replace(/,{2,}/g,',')}</span> */}
        </div>
        <div className='request-properties-card__floor'>
            <img src={FloorPlanIcon} alt={""} /><span>{floorPlan}</span>
        </div>
        <div className='request-properties-card__dates'>
            <img src={CalendarIcon} alt={""} /><span>{dates}</span>
        </div>
          <div className='request-properties-card__status'>
              <span className='request-properties-card__status__tag'>{RequestHelper.getRequestPropertyStatus(cancelledStatus)}</span>
          </div>
        <div className='request-properties-card__buttons'>
            <div className='request-properties-card__buttons__content'>
                <Link target='_blank' to={`/property/dashboard/${id}`} className='request-properties-card__buttons__content__view'><img src={ViewIcon}/><span>View</span></Link>
                  {!hiddeActions && (cancelledStatus !==  REQUESTED_PROPERTY_DECLINE_REASON.DeclinedByGuest && cancelledStatus !==  REQUESTED_PROPERTY_DECLINE_REASON.DeclinedByManager && cancelledStatus !==  REQUESTED_PROPERTY_DECLINE_REASON.DeclinedBySUpplier) && <div className='request-properties-card__buttons__content__delete'><DeleteIcon/><span onClick={cancelRequestedProperty}>Delete</span></div>}
            </div>
        </div>
        <div className='request-properties-card__divisor'></div>
    </div>
  )
}

export default RequestPropertiesCard